import Layout from 'components/layouts/Layout'
import { GetStaticProps } from 'next'
import { useTranslations } from 'next-intl'
import { ReactElement } from 'react'
import FeaturesLayout from '../../../components/layouts/features/FeaturesLayout'
import DocPage from '../../../components/DocPage'
import Video from 'components/commons/Video'
import Image from 'components/commons/Image'
import ImageExample from 'public/static/images/planeamento/plano de pagamentos+cronograma.png'

const translations = "planeamento/obter-o-plano-de-pagamentos"

const Doc = () => {
  const t = useTranslations(translations)

  return (
    <DocPage group={t("group")} title={t("title")} metadata={{ title: t("metadata-title"), description: t("metadata-description") }} previous={{ name: t("previous-name"), to: t("previous-to") }} next={{ name: t("next-name"), to: t("next-to") }}>
      <p>{t("details-1")}</p>
      <p>{t("details-2")}</p>
      <Image
        title={t("image-1-title")}
        href={t("image-1-src")}
        width={700}
        height={700}
      />
      <p>{t("details-3")}</p>
      <p>{t("details-4")}</p>
      <Video
        id={t("video-1-id")}
        title={t("video-1-title")}
      />
    </DocPage>
  )
}

export const getStaticProps: GetStaticProps = async context => {
  return {
    props: {
      context,
      messages: (await import(`../../../lang/${context.locale}-docs.json`)).default
    }
  }
}

Doc.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout variant='secondary'>
      <FeaturesLayout >
        {page}
      </FeaturesLayout>
    </Layout>
  )
}

export default Doc
